import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../util/supabaseClient";
import "./GroupPage.css";

const SHARE_ID_LENGTH = 8;

export default function GroupPage() {
  const { slug } = useParams();

  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const shareId = slug?.slice(-SHARE_ID_LENGTH);

  useEffect(() => {
    const fetchGroup = async () => {
      if (!shareId) {
        setErrorMessage("Invalid group link.");
        setLoading(false);
        return;
      }

      setLoading(true);
      setErrorMessage("");

      const { data, error } = await supabase
        .from("public_groups")
        .select(`
          name,
          share_id,
          group_image_url,
          color,
          member_count,
          post_count
        `)
        .eq("share_id", shareId)
        .maybeSingle();

      if (error) {
        console.error("Error loading group:", error);
        setErrorMessage("Unable to load this group.");
        setLoading(false);
        return;
      }

      if (!data) {
        setErrorMessage("Group not found.");
        setLoading(false);
        return;
      }

      setGroup(data);
      setLoading(false);
    };

    fetchGroup();
  }, [shareId]);

  if (loading) {
    return (
      <div className="group-page group-page-default">
        <div className="group-loading">
          Loading group...
        </div>
      </div>
    );
  }

  if (errorMessage || !group) {
    return (
      <div className="group-page group-page-default">
        <div className="group-error">
          <h2>Group not found</h2>
          <p>{errorMessage}</p>
        </div>
      </div>
    );
  }

  const groupColor = group.color
  ? group.color.startsWith("#")
    ? group.color
    : `#${group.color}`
  : "#f7f7f9";

  return (
    <div
    className="group-page"
    style={{
        backgroundColor: groupColor,
    }}
    >
      <main className="group-container">

        <header className="group-header">

          {group.group_image_url && (
            <img
              src={group.group_image_url}
              alt={group.name}
              className="group-image"
            />
          )}
{/*
          <div className="group-label">
            Intuuch Group
          </div>*/}

          <h1 className="group-name">
            {group.name}
          </h1>

        </header>

        <section className="group-card">

          <div className="group-stats">

            <div className="group-stat">
              <strong>
                {group.member_count ?? 0}
              </strong>

              <span>
                {(group.member_count ?? 0) === 1
                  ? "Member"
                  : "Members"}
              </span>
            </div>

            <div className="group-stat-divider" />

            <div className="group-stat">
              <strong>
                {group.post_count ?? 0}
              </strong>

              <span>
                {(group.post_count ?? 0) === 1
                  ? "Activity"
                  : "Activities"}
              </span>
            </div>

          </div>

            <button
            type="button"
            className="open-app-button"
            onClick={() => {
              
                window.location.href = `https://open.intuuch.app/groups/${encodeURIComponent(slug)}`// "https://apps.apple.com/us/app/id6749470124"
            }}
            >
            Open in Intuuch
            </button>
{/*}
          <a
            href={`https://intuuch.app/groups/${slug}`}
            className="open-app-button"
          >
            Open in Intuuch
          </a>*/}

   
       
        <p className="group-footer-text">
          <a href="https://apps.apple.com/us/app/id6749470124">
            Download on the App Store
          </a>
          </p>
{/*}
          <p className="group-footer-text">
            Don't have Intuuch yet? 
            <a className="group-footer-text" href="https://apps.apple.com/us/app/xxx/idYOUR_APP_ID">
            Download the app to join this group.
          </a>
          </p>*/}
       

        </section>

      </main>
    </div>
  );
}

